/// <amd-module name="Test/FailedTestsMetricView/Actions/FailedTestsMetricActionsCreator" />
import { AnnouncementActions } from "Test/Analytics/Common/Actions/AnnouncementActions";
import * as CommonTypes from "Test/Analytics/Common/Types";
import * as TcmPerfScenarios from "Test/Analytics/Common/Utils/TCMPerfScenarios";
import { isShowFlakyTestsDetailsEnabled } from "Test/Analytics/Common/Utils/FeatureFlagUtils";
import * as TcmTelemetryConstants from "Test/Analytics/Common/Utils/TcmTelemetryConstants";
import { publishEvent } from "Test/Analytics/Common/Utils/TelemetryService";
import { FailedTestsMetricActions } from "Test/FailedTestsMetricView/Actions/FailedTestsMetricActions";
import * as Resources from "Test/FailedTestsMetricView/Resources";
import { FailedTestsMetricSource } from "Test/FailedTestsMetricView/Sources/FailedTestsMetricSource";
import { PassRateChartSource } from "Test/PassRateChartView/Sources/PassRateChartSource";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssPerformanceService } from "VSS/Platform/Performance";

export class FailedTestsMetricActionsCreator {
    private _failedTestsMetricSource: FailedTestsMetricSource;
    private _passedRateChartSource: PassRateChartSource;
    private _perfService: IVssPerformanceService;
    constructor(
        private _actions: FailedTestsMetricActions,
        private _announcementActions: AnnouncementActions,
        private _pageContext: IVssPageContext
    ) {
        this._failedTestsMetricSource = new FailedTestsMetricSource(_pageContext);
        this._passedRateChartSource = new PassRateChartSource(_pageContext);
        this._perfService = _pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
    }

    public updateConfigurationValues(newConfValues: CommonTypes.IReportConfiguration): void {
        this._actions.updateConfigurationValuesAction.invoke(newConfValues);
    }

    public updateFailedTestsMetric(testReportContext: CommonTypes.ITestReportContext, confValues: CommonTypes.IReportConfiguration): Promise<void> {
        this._perfService.startScenario(TcmPerfScenarios.TestAX_FailedTestsCard, false);
        const failedMetricsPromise = this._failedTestsMetricSource.queryTotalFailingTestsMetricData(testReportContext, confValues);
        const cardMetricsPromise = this._passedRateChartSource.queryTestOutcomeCountMetricData(testReportContext, confValues);

        return Promise.all([failedMetricsPromise, cardMetricsPromise]).then(
            metricsData => {
                const failedMetricsCardData = metricsData[0];
                const passedRateChartData = metricsData[1];

                failedMetricsCardData.totalFailedResultsCount = passedRateChartData.failedCount;

                this._actions.updateFailedTestsMetricAction.invoke(failedMetricsCardData);
                this._announcementActions.announceAction.invoke(Resources.FailedTestsMetricLoaded);
                this._perfService.endScenario(TcmPerfScenarios.Area, TcmPerfScenarios.TestAX_FailedTestsCard, false);

                // Telemetry
                const telemetryData: { [key: string]: string | number } = {
                    [TcmTelemetryConstants.FailedTests]: failedMetricsCardData.totalFailingTestsCount,
                    [TcmTelemetryConstants.IsCached]: String(failedMetricsCardData.isCachedData)
                };
                publishEvent(this._pageContext, TcmTelemetryConstants.featureTestAX_FailedTestsCard, telemetryData, testReportContext, confValues);
            },
            error => {
                this._actions.onError.invoke(error);
                this._perfService.endScenario(TcmPerfScenarios.Area, TcmPerfScenarios.TestAX_FailedTestsCard, false, undefined, { status: "error" });
            }
        );
    }

    public updateFlakyTestsMetric(testReportContext: CommonTypes.ITestReportContext, confValues: CommonTypes.IReportConfiguration): Promise<void> {
        if (!isShowFlakyTestsDetailsEnabled(this._pageContext)) {
            return Promise.resolve();
        }
        this._perfService.startScenario(TcmPerfScenarios.TestAX_FlakyTestsCard, false);
        return this._failedTestsMetricSource.queryTotalFlakyTestsMetricData(testReportContext, confValues).then(
            failedMetricsCardData => {
                let flakyData = failedMetricsCardData ? failedMetricsCardData.totalFailingTestsCount : 0;

                this._actions.updateFlakyTestsMetricAction.invoke(flakyData);
                this._announcementActions.announceAction.invoke(Resources.FlakyTestsMetricLoaded);
                this._perfService.endScenario(TcmPerfScenarios.Area, TcmPerfScenarios.TestAX_FlakyTestsCard, false);

                // Telemetry
                const telemetryData: { [key: string]: string | number } = {
                    [TcmTelemetryConstants.FailedTests]: failedMetricsCardData.totalFailingTestsCount,
                    [TcmTelemetryConstants.IsCached]: String(failedMetricsCardData.isCachedData)
                };
                publishEvent(this._pageContext, TcmTelemetryConstants.featureTestAX_FlakyTestsCard, telemetryData, testReportContext, confValues);
            },
            error => {
                this._actions.onError.invoke(error);
                this._perfService.endScenario(TcmPerfScenarios.Area, TcmPerfScenarios.TestAX_FlakyTestsCard, false, undefined, { status: "error" });
            });
    }
}